
define('text!modules/core/modules/utils/directives/privacy-button/template.html',[],function () { return '<i class=font:gizmo>&#x1F512;</i>';});

